import { Theme, ThemeUICSSObject } from '@apia/theme';
/* IMPORT HERE */

const reschedule: ThemeUICSSObject = {
  '.danger': {
    borderLeftColor: (theme: Theme) => theme.palette.error.main,
    borderLeftWidth: '5px',
  },
};

export default reschedule;
